import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const API_CALCULATION_URL = '/api/qntcal';

@Injectable({
  providedIn: 'root'
})
export class CalculationService {
  constructor(private http: HttpClient) { }

  // Load parents
  loadParents(): Observable<any[]> {
    return this.http.get<any[]>(`${API_CALCULATION_URL}/get-parents-with-children`);
  }

  // Create calculation
  createCalculation(data: any): Observable<any> {
    console.log('data', data);
    return this.http.post<any>(`${API_CALCULATION_URL}/create-calculation`, data);
  }

  // Add calculation
  createonebyone(uuid: string, data: any): Observable<any> {
    console.log('data', data);
    console.log('uuid', uuid);
    return this.http.post<any>(`${API_CALCULATION_URL}/add-calculation/${uuid}`, data);
  }

  // Get calculations by UUID
  getCalculationsByUUID(uuid: string): Observable<any> {
    return this.http.get<any>(`${API_CALCULATION_URL}/get-calculations/${uuid}`);
  }

  // Delete calculation
  deleteCalculation(uuid: string, calculationId: string): Observable<any> {
    return this.http.delete<any>(`${API_CALCULATION_URL}/delete-calculation/${uuid}/${calculationId}`);
  }

  // Edit calculation
  editCalculation(projectId: string, updatedCalculation: any, editItemID: string): Observable<any> {
    console.log('Updated Calculation:', updatedCalculation);
    return this.http.put<any>(`${API_CALCULATION_URL}/edit-calculation/${projectId}`, {
      calculation: updatedCalculation,
      editItemID
    });
  }
}